import { type WithdrawTransaction, HarvestTypeFilter } from '../types/withdrawals.types'

export function transactionMatchesFilter(txn: WithdrawTransaction, activeFilters: HarvestTypeFilter[]): boolean {
  if (activeFilters.length === 0 || activeFilters.includes(HarvestTypeFilter.ALL)) return true
  const info = txn?.financialYearCapitalGains
  if (!info) return false
  return activeFilters.some((f) => {
    if (f === HarvestTypeFilter.LTCG && (info?.ltcg ?? 0) !== 0) return true
    if (f === HarvestTypeFilter.STCG && (info?.stcg ?? 0) !== 0) return true
    if (f === HarvestTypeFilter.LTCL && (info?.ltcl ?? 0) !== 0) return true
    if (f === HarvestTypeFilter.STCL && (info?.stcl ?? 0) !== 0) return true
    return false
  })
}
